document.querySelectorAll('.share-btn').forEach((button) => {
  button.addEventListener('click', function () {
    const productUrl = button.getAttribute('data-url'); // Get URL from data attribute
    const productTitle = button.getAttribute('data-title'); // Get title from data attribute

    if (navigator.share) {
      navigator
        .share({
          title: productTitle,
          url: productUrl,
        })
        .then(() => console.log('Product URL shared successfully!'))
        .catch((error) => console.error('Error sharing:', error));
    } else {
      alert('Your browser does not support the Share feature.');
    }
  });
});
